import type { MouseEvent } from 'react'
import { trackInitiateCheckout } from './metaPixel'

export const checkoutUrl =
  'https://43skvt-1y.myshopify.com/products/codigo-fitness-sistema-completo-de-alimentacion-saludable'

export function openCheckout() {
  trackInitiateCheckout()

  const attributedCheckoutUrl = getAttributedCheckoutUrl()

  if (window.self !== window.top) {
    window.open(attributedCheckoutUrl, '_blank', 'noopener,noreferrer')
    return
  }

  window.location.href = attributedCheckoutUrl
}

export function handleCheckoutClick(event: MouseEvent<HTMLAnchorElement>) {
  event.preventDefault()
  openCheckout()
}

function getAttributedCheckoutUrl() {
  const destination = new URL(checkoutUrl)
  const currentParams = new URLSearchParams(window.location.search)
  const fbclid = currentParams.get('fbclid')
  const fbp = getCookieValue('_fbp')
  const fbc = getCookieValue('_fbc')

  if (fbclid) {
    destination.searchParams.set('fbclid', fbclid)
  }

  if (fbp) {
    destination.searchParams.set('_fbp', fbp)
  }

  if (fbc) {
    destination.searchParams.set('_fbc', fbc)
  }

  return destination.toString()
}

function getCookieValue(cookieName: string) {
  const cookie = document.cookie
    .split('; ')
    .find((entry) => entry.startsWith(`${cookieName}=`))

  return cookie
    ? decodeURIComponent(cookie.split('=').slice(1).join('='))
    : null
}
